export const cvvTooltipHideDelay = 700;
